import i18n from 'i18n'
import * as React from "react"
import { CascaderAjaxSeeker, IconSeekers } from "ui-seeker/core"
import { FORMAT_DATE_BACK, formatDate } from 'ui-seeker/utils'

import { SelectLoading } from "app/components/loading"
import { COMPETITION_URL, FEATURES } from 'app/@common/constants'
import { localizedRoom } from 'app/@utils/catalog'

// Solución ÚNICA y COMPARTIDA del selector de rooms (aplica a TODOS los dashboards, no es per-dashboard).
// Cascader de 2 niveles: padre = room normalizado (value = id_room numérico) → localizedRoom (ES=name, EN=rooms.json);
// hijos = raw OTA (value = string) → NO se traduce. Display-only: el value/selección no se toca.
const renderRoomMenuItem = (label, item) =>
    typeof item?.value === 'number' ? localizedRoom({ id_room: item.value, name: label }) : label


export default function SelectRawRooms({ customDates, sitePackageID, selectedRoute, onLoadingChange, section, ...props }) {

    if (!props.date || (section === FEATURES.COMPETITION && !props.sites) || !props.occupancy || !props.nights) return <SelectLoading />
    if (section === 'packages' && (!selectedRoute?.length || !sitePackageID?.length)) return <SelectLoading />

    return <CascaderAjaxSeeker
		urlAjax={COMPETITION_URL.ROOMS}
        filters={{
            boardID: props.board,
            id_rate: props.rate,
            dateRange: props.date,
            nights: props.nights,
            occupancy: props.occupancy,
            devices: props.devices,
            hotelID: props.hotels,
            info: props.info,
            siteID: props.sites,
            ...section === 'competition' && !props.sites && { id_site: props.sites },
            ...selectedRoute?.length && { routes: selectedRoute },
            ...sitePackageID?.length ? { sitePackageID: sitePackageID } : { id_site: props.sites },
            ...props.refresh && { refresh_cache: props.refresh },
            ...props.id_report_execution && { id_report_execution: props.id_report_execution },
            ...'id_main_hotel' in props && { id_main_hotel: props.id_main_hotel },
            ...props.date === 'custom' && {
                startDate: formatDate(customDates[0], { format: FORMAT_DATE_BACK }),
                endDate: formatDate(customDates[1], { format: FORMAT_DATE_BACK })
            }
        }}
        className="cascader-rooms"
		label=""
        method='POST'
		placeholder={<>
            <IconSeekers icon="bed" iconType="fontAwesome" style={{ color: 'var(--primary)' }} />
            <span style={{ marginLeft: '10px' }}>{i18n.t('common:filters.allRoomTypes')}</span>
        </>}
        menuWidth={350}
        container={() => document.body}
        preventOverflow
		{...props}
		renderMenuItem={renderRoomMenuItem}
	/>
}